<template>
    <v-btn-toggle v-model="query['mode_auction']" tile color="secondary" @change="emit">
        <template v-for="item in items">
            <v-btn class="px-6" :value="item.value" :key="item.value">
                {{ item.text }}
            </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import { WORK_AUCTION_MODES } from "@/assets/variables";

let initQuery = (query = {}) => ({
    ...(query || {}),
    ["mode_auction"]: query?.["mode_auction"] || null,
});

let items = [
    {
        text: "전체",
        value: null,
    },
    WORK_AUCTION_MODES.PROGRAM,
    WORK_AUCTION_MODES.PRIVATE,
    WORK_AUCTION_MODES.PERMANENT,
];

export default {
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];
            if (query["mode_auction"] == null) delete query["mode_auction"];

            this.$router.push({ query });
        },
    },
    watch: {
        ["$route.query"]() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
